export default __webpack_public_path__ + "static/media/dichma.f06b4c18.png";